import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Balance from '../components/Balance';
import Form from '../components/Form';
import TransActionItem from '../components/TransActionItem';
import Loading from '../components/ui/Loading';
import { fetchTransactions } from '../features/transactions/transactionsSlice';

function Home() {
    const { transactions, isLoading, isError, error } = useSelector((state) => state.transaction);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTransactions({ type: '', search: '' }));
    }, [dispatch]);

    const latestTransactions = [...transactions].reverse().slice(0, 5);

    let content = null;

    if (isLoading) {
        content = <Loading />;
    }
    if (isError) {
        content = <p>{error}</p>;
    }
    if (!isLoading && !isError && transactions.length === 0) {
        content = <p>Transaction not fount</p>;
    }
    if (!isLoading && !isError && transactions.length > 0) {
        content = latestTransactions.map((transaction) => (
            <TransActionItem key={transaction.id} transaction={transaction} />
        ));
    }

    return (
        <>
            <Balance />
            <Form />
            <div className="conatiner_of_list_of_transactions">
                <ul>{content}</ul>
                <Link to="/transactions">
                    <button
                        type="button"
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                        <svg
                            aria-hidden="true"
                            className="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <span className="sr-only">Icon description</span>
                    </button>
                </Link>
            </div>
        </>
    );
}

export default Home;
